<template>
  <TopNav></TopNav>
  <h1>Deprem Karşılaştırma</h1>
  <fieldset>
    <legend>Deprem Karşılaştırma Aracı</legend>
    <label for="a" title="birinci deprem">A Depremi: </label> <input type="number" v-model.number="adepremi" id="a" step="any" min="0"> <span title="moment magnitüd ölçeği">M<sub>w</sub></span>
    <br>
    <label for="b" title="ikinci deprem">B Depremi: </label> <input type="number" v-model.number="bdepremi" id="b" step="any" min="0"> <span title="moment magnitüd ölçeği">M<sub>w</sub></span>
    <br><br>
    Sarsıntı farkı <span class="blue">{{ sarsinti() }}</span> katı.<br><br>
    Enerji farkı <span class="blue">{{ enerji() }}</span> katı.
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "DepremKarsilastirma",
  data() {
    return {
      adepremi: 6,
      bdepremi: 7,
    }
  },
  components: {
    TopNav
  },
  methods: {
    sarsinti: function () {
      const formatter = new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 10
      });
      let shaking = 0;
      let diff = this.adepremi - this.bdepremi;
      let absolut = Math.abs(diff);
      shaking = Math.pow(10, absolut);
      const shakingNumber = Number(shaking);
      return formatter.format(shakingNumber);
    },
    enerji: function () {
      const formatter = new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 10
      });
      let shaking = 0;
      let diff = this.adepremi - this.bdepremi;
      let absolut = Math.abs(diff);
      shaking = Math.pow(10, absolut * 1.5);
      const shakingNumber = Number(shaking);
      return formatter.format(shakingNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 110px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
